import { HStack, Stack, Text } from "@chakra-ui/react";
import { Form, UI } from "components";
import { Mask } from "config";
import useUser from "hooks/useUser";
import moment from "moment";

export default function Personal(){

    const user = useUser()

    return(
    <UI.Box loading={user.isFetching} h="auto">
        <Stack gap={4}>
            <Text children="Dados pessoais:" size="xs" color="GrayText" />

            <Form.Text 
                required
                readOnly
                variant="subtle"
                label="Nome completo:"
                value={user.data?.name}
                size="lg"
                helper="Para alterar seu nome, por favor contate o suporte."
            />

            <HStack>
                <Form.Text 
                    required
                    readOnly
                    label="Data de nascimento:"
                    value={moment(user.data?.dob).utc().format('DD/MM/YYYY')}
                />

                <UI.Show visible={!!user.data?.doc_cpf}>
                    <Form.Text 
                        readOnly
                        label="Tipo de documento:"
                        value="CPF"
                    />

                    <Form.Text 
                        required
                        readOnly
                        label="CPF:"
                        value={Mask.cpf(user.data?.doc_cpf ?? '')}
                    />
                </UI.Show>

                <UI.Show visible={!!user.data?.doc_international}>
                    <Form.Text 
                        readOnly
                        label="Tipo de documento:"
                        value="Internacional"
                    />

                    <Form.Text 
                        required
                        readOnly
                        label="Documento:"
                        value={user.data?.doc_international}
                    />
                </UI.Show>
            </HStack>

            <UI.Alert size="sm">Dados pessoais como <b>nome</b>, <b>documento</b> e <b>data de nascimento</b> só podem ser alterados mediante abertura de chamado no suporte.</UI.Alert>
        </Stack>
    </UI.Box>
    )
}